import { render, staticRenderFns } from "./CardRowTabReadOnly.vue?vue&type=template&id=b79f84b4&"
import script from "./CardRowTabReadOnly.vue?vue&type=script&lang=js&"
export * from "./CardRowTabReadOnly.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports